<div class="d-flex justify-content-between align-items-center gap-10 w-100">
    <div class="two-lines" [class.text-primary-p8]="isAutoGenerated()">
        {{ dateDisplay().time }}<br />{{ dateDisplay().date }}
    </div>
    @if (isAutoGenerated()) {
    <i class="icon icon-robot fs-4 text-primary-p8" title="Auto generate"></i>
    }
</div>
